export default __webpack_public_path__ + "static/media/videoOffNew.1077dd2f.svg";